/**
 * UX cadence constants for the per-shot animation chain.
 * Sequential reveal model (spec §Q5): swipe → keeper dive → ball flight →
 * outcome flash. Reduced-motion replaces all four with an instant snap held
 * briefly so keeper's chosen zone remains legible (Bayesian-loop requirement).
 */
export const SHOT_TIMING_MS = {
  ballFlight: 800,
  keeperDive: 400,
  outcomeFlash: 500,
  reducedMotionHold: 200,
} as const;

import { createUiPrefs } from './ui-prefs';

/**
 * Returns a multiplier applied to SHOT_TIMING_MS values when reduced motion
 * is requested. 0 = skip animation. 1 = full duration.
 *
 * The PlayScene reads this once at scene.create() per spec §3.2 settings
 * read timing. Mid-shot toggles do not take effect until the next shot or
 * scene boundary.
 */
export function reducedMotionScale(storage: Storage = window.localStorage): 0 | 1 {
  return createUiPrefs(storage).getReducedMotion() ? 0 : 1;
}
